<style src="./CostEdition.scss" lang="scss"></style>
<template>
  <section class="cost-edition">
    <section class="commands" v-if="!associationMode.isAssociationMode">
      <button
        @click="notQuoteItem"
        type="button"
        class="btn btn-small-danger">
        NÃO ESCOLHER
      </button>
      <button
        @click="saveChoice"
        type="button"
        class="btn btn-small-success">
        SALVAR
      </button>
    </section>
    <section
      v-if="!associationMode.isAssociationMode"
      class="item-description">
      <div class="id">
        <span class="badge lot" v-if="!!info.itemInfo.lot">LOTE {{ info.itemInfo.lot }}</span>
        <span class="badge number">ITEM {{ info.itemInfo.number }}</span>
      </div>

      <span class="description">{{ info.itemInfo.description }}</span>

      <div class="iteminfo">
        <span class="number quantity"><small>QT:</small> <strong>{{ info.itemInfo.quantity | DecimalNumber }}</strong></span>
        <span class="number factor"><small>x</small><strong>{{ info.itemInfo.factor | DecimalNumber }}</strong></span>
        <span class="number estimated"><small>ESTIMADO: R$</small> <strong>{{ info.itemInfo.estimatedPrice | CurrencyBR('Não Informado') }}</strong></span>
        <span class="number unity">{{ info.itemInfo.unity }}</span>
      </div>
    </section>

    <span
      v-if="countWaiting > 0 && !associationMode.isAssociationMode"
      class="waitingquotation">
      Existe{{ countWaiting > 1 ? 'm' : '' }} {{ countWaiting }} item{{ countWaiting > 1 ? 's' : '' }} aguardando retorno da cotação
    </span>

    <!-- ASSOCIATION -->
    <associate-item
      v-if="associationMode.isAssociationMode"
      :item-id="info.itemId"
      :info="info"
      @finish-edition="finishAssociationItem"
      @cancel-edition="cancelAssociateEdition" />

    <section
      v-if="!associationMode.isAssociationMode"
      class="list associated">
      <div class="choices">
        <span class="title">ASSOCIADO</span>
        <button
          type="button"
          @click="openAssociationItem(associatedItem)"
          class="editbutton">
          Editar
        </button>
      </div>
      <div
        v-if="!associatedItem.isAssociated && !associationMode.isAssociationMode"
        class="notmentioned">
        Não Associado
      </div>


      <div
        v-if="associatedItem.isAssociated"
        class="item associated"
        @click="selectAssociated">
        <section class="info">
          <span class="lab">{{ associatedItem.lab }}</span>
          <span class="pativo">{{ associatedItem.pativo }}</span>
          <span class="comercialname">{{ associatedItem.comercialName }}</span>
        </section>

        <div class="values">
          <span class="title">Preço</span>
          <span class="price"><small>R$ </small>{{ associatedItem.price | CurrencyBR('', 4) }}</span>
          <span class="total"><small>TOTAL R$ </small>{{ associatedItem.priceTotal | CurrencyBR }}</span>
          
          <span class="title mt">Máximo</span>
          <span class="price"><small>R$ </small>{{ associatedItem.cmedPrice | CurrencyBR('', 4) }}</span>
        </div>
      </div>
    </section>

    <!-- QUOTES -->
    <section
      v-if="!associationMode.isAssociationMode"
      class="list quoted">
      <span class="choices">COTADO</span>
      <div
        v-if="info.quotations.length === 0"
        class="notmentioned">
        Não cotado
      </div>

      <template v-if="info.quotations.length > 0">
        <div
          v-for="(quote, quotesIdx) in quotations"
          :key="quotesIdx"
          @click="selectQuoted(quote)"
          class="item quoted">
          <div class="info">
            <span class="lab">{{ quote.lab }}</span>
            <span class="pativo">
              <icon-star title="Item com garantia de preço" v-if="quote && quote.isPriceGuaranted" />
              {{ quote.pativo }}
            </span>
            <span class="comercialname">{{ quote.comercialName }}</span>
          </div>

          <div class="values">
            <span class="title">Preço</span>
            <span class="price"><small>R$ </small>{{ quote.price | CurrencyBR('', 4) }}</span>
            <span class="total"><small>TOTAL R$ </small>{{ quote.priceTotal | CurrencyBR }}</span>

            <span class="title mt">Máximo</span>
            <span class="price"><small>R$ </small>{{ quote.cmedPrice | CurrencyBR('', 4) }}</span>
          </div>
        </div>
      </template>
    </section>
  </section>
</template>

<script>
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'
import { IconSave, IconStar } from '@/components/primitives/icons'
import { SuggestProductDetails } from '@/components/primitives'
import DefineLowestMaxPrice from '@/brain/item-pricing/define-lowest-max-price'
import AssociateItem from '../associate-item/AssociateItem'

export default {
  name: 'CostEdition',
  components: {
    IconStar,
    IconSave,
    SuggestProductDetails,
    AssociateItem
  },
  props: {
    info: {
      default: () => ({})
    }
  },
  data: () => ({
    associationMode: {
      isAssociationMode: false,
      product: null
    },
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    },
    associatedItem: {},
    finalQuote: {
      supplier: null,
      item: null,
      price: null,
      priceTotal: null,
      isPriceGuaranted: null,
      notQuote: null,
      cmedPrice: null,
      cmedTotalPrice: null,
      cmedLab: null,
      lab: null
    }
  }),
  filters: {
    CurrencyBR,
    DecimalNumber
  },
  computed: {
    quotations () {
      return this.info.quotations.filter(i => !i.notQuote && i.receiveDate)
    },
    countWaiting () {
      return this.info.quotations.length - this.quotations.length
    }
  },
  watch: {
    'info': {
      handler () {
        this.associatedItem = { ...this.info.associated }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    selectQuoted (item) {
      this.finalQuote.supplier = item.supplier
      this.finalQuote.item = item.itemId
      this.finalQuote.price = item.price
      this.finalQuote.priceTotal = item.price * this.info.itemInfo.quantity * this.info.itemInfo.factor
      this.finalQuote.isPriceGuaranted = item.isPriceGuaranted
      this.finalQuote.cmedLab = item.cmedLab
      this.finalQuote.cmedPrice = item.cmedPrice
      this.finalQuote.cmedTotalPrice = item.cmedPrice * this.info.itemInfo.quantity * this.info.itemInfo.factor
      this.finalQuote.cmedPerc = (((item.cmedPrice * 100) / item.price) - 100).toFixed()
      this.finalQuote.notQuote = false
      this.finalQuote.lab = item.lab
      this.finalQuote.proposalPrice = (item.price * ((this.$store.getters['ItemPricing/PROPOSAL_MARGIN'] / 100) + 1)).toFixed(this.$store.getters['ItemPricing/DECIMAL_PRECISION'])
      this.finalQuote.proposalTotalPrice = this.finalQuote.proposalPrice * this.info.itemInfo.quantity * this.info.itemInfo.factor
      this.finalQuote.proposalPerc = (((this.finalQuote.proposalPrice * 100) / item.price) - 100).toFixed()
      this.finalQuote.minimumPrice = this.finalQuote.proposalPrice
      this.finalQuote.minimumTotalPrice = this.finalQuote.proposalTotalPrice
      this.finalQuote.minimumPerc = this.finalQuote.proposalPerc

      // Get the lowest value between Cmed and estimated as long as it's not zero
      const lowerValue = DefineLowestMaxPrice(this.finalQuote.cmedPrice, this.info.itemInfo.estimatedPrice)

      // Check if proposal is higher than max price
      const isHigherThanMax = this.finalQuote.proposalPrice > lowerValue
      this.finalQuote.proposalIsHigherThanMaxprice = isHigherThanMax
      this.finalQuote.minimumIsHigherThanMaxprice = isHigherThanMax
    },
    selectAssociated () {
      this.finalQuote.supplier = this.associatedItem.supplier
      this.finalQuote.item = this.associatedItem.itemId
      this.finalQuote.price = this.associatedItem.price
      this.finalQuote.priceTotal = this.associatedItem.price * this.info.itemInfo.quantity * this.info.itemInfo.factor
      this.finalQuote.isPriceGuaranted = false
      this.finalQuote.cmedLab = this.associatedItem.cmedLab
      this.finalQuote.cmedPrice = this.associatedItem.cmedPrice
      this.finalQuote.cmedTotalPrice = this.associatedItem.cmedPrice * this.info.itemInfo.quantity * this.info.itemInfo.factor
      this.finalQuote.cmedPerc = (((this.associatedItem.cmedPrice * 100) / this.associatedItem.price) - 100).toFixed()
      this.finalQuote.notQuote = false
      this.finalQuote.lab = this.associatedItem.lab

      this.finalQuote.proposalPrice = (this.associatedItem.price * ((this.$store.getters['ItemPricing/PROPOSAL_MARGIN'] / 100) + 1)).toFixed(this.$store.getters['ItemPricing/DECIMAL_PRECISION'])
      this.finalQuote.proposalTotalPrice = this.finalQuote.proposalPrice * this.info.itemInfo.quantity * this.info.itemInfo.factor
      this.finalQuote.proposalPerc = (((this.finalQuote.proposalPrice * 100) / this.associatedItem.price) - 100).toFixed()
      this.finalQuote.minimumPrice = this.finalQuote.proposalPrice
      this.finalQuote.minimumTotalPrice = this.finalQuote.proposalTotalPrice
      this.finalQuote.minimumPerc = this.finalQuote.proposalPerc

      // Get the lowest value between Cmed and estimated as long as it's not zero
      const lowerValue = DefineLowestMaxPrice(this.finalQuote.cmedPrice, this.info.itemInfo.estimatedPrice)

      // Check if proposal is higher than max price
      const isHigherThanMax = this.finalQuote.proposalPrice > lowerValue
      this.finalQuote.proposalIsHigherThanMaxprice = isHigherThanMax
      this.finalQuote.minimumIsHigherThanMaxprice = isHigherThanMax
    },
    notQuoteItem () {
      this.finalQuote.supplier = null
      this.finalQuote.item = null
      this.finalQuote.price = null
      this.finalQuote.priceTotal = null
      this.finalQuote.isPriceGuaranted = false
      this.finalQuote.notQuote = true
      this.finalQuote.lab = false
      this.finalQuote.cmedLab = null
      this.finalQuote.cmedPrice = null
      this.finalQuote.cmedTotalPrice = null

      this.finalQuote.proposalTotalPrice = null
      this.finalQuote.proposalPerc = null
      this.finalQuote.minimumPrice = null
      this.finalQuote.minimumTotalPrice = null
      this.finalQuote.minimumPerc = null

      this.saveChoice()
    },
    async saveChoice () {
      this.commands.submitState = 'WAIT'

      try {
        const payload = {
          quote: this.info.itemId,
          ...this.finalQuote
        }
        const info = await this.$store.dispatch('ItemPricing/SELECT_QUOTE_ITEM', payload)
        this.$store.commit('ItemPricing/SET_ITEM', {
          itemId: this.info.itemId,
          info
        })
        this.$toasted.success('Item salvo')
      } catch (error) {
        this.$toasted.error('Não foi possível salvar')
      } finally {
        this.commands.submitState = 'REPOSE'
      }
    },
    openAssociationItem (item) {
      this.associationMode.isAssociationMode = true
    },
    finishAssociationItem () {
      this.associationMode.isAssociationMode = false
      this.$emit('refresh-edition')
    },
    cancelAssociateEdition () {
      this.associationMode.isAssociationMode = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/item-pricing/components/cost-edition/CostEdition.vue